import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idioma: localStorage.getItem('lang') || undefined,
    showTransition: false
  },
  mutations: {
    SET_IDIOMA(state, lang) {
      localStorage.setItem('lang', lang);
      state.idioma = lang;
    },
    SET_SHOW_TRANSITION(state, value) {
      state.showTransition = value;
    },
  },
  actions: {
    setIdioma({commit}, data) {
      commit('SET_IDIOMA', data);
    },
    activateTransition({commit}) {
      commit('SET_SHOW_TRANSITION', true);
    },
    deactivateTransition({commit}) {
      commit('SET_SHOW_TRANSITION', false);
    },
  }
})
